import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsgetMoodVod } from '../../../entity/interface/iThinkAnalytics';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';

export interface IGetMoodVodUseCase {
    execute(
        apiKey: string,
        token: string,
        profileName: string,
        userName: string,
        device: string,
        country: string,
        subGuids: string,
        rating: string,
        useCaseId: string
    ): Promise<IThinkAnalyticsgetMoodVod>;
}

export class GetMoodVodUseCase implements IGetMoodVodUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get thinkAnalyticsRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        token: string,
        profileName: string,
        userName: string,
        device: string,
        country: string,
        subGuids: string,
        rating: string,
        useCaseId: string
    ): Promise<IThinkAnalyticsgetMoodVod> {
        return this.thinkAnalyticsRepository.getMoodVod(
            apiKey,
            token,
            profileName,
            userName,
            device,
            country,
            subGuids,
            rating,
            useCaseId
        );
    }
}
